const Ecosystem = () => {
  return (
    <>
      <section id="ecosys" className="WhatPrcog DiscoverPrcog">
        <div className="container">
          <div className="row position-relative">
            <div className="col-12">
              <div className="backimg">
                <img src="/images/discoverback.png" alt="" />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="heading">
                <img src="/images/boult.png" className="mb-3" alt="" />
                <h4>The Zeuss Ecosystem</h4>
                <p>
                  Zeuss Token is driving innovation in decentralized
                  communication, commerce, and finance.
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 col-md-6 col-lg-7">
              <div className="discovercontent">
                <div className="image">
                  <img src="/images/eco1.png" alt="" />
                </div>
                <div className="contenttxt">
                  <h4>Z Chat</h4>
                  <p>
                    A decentralized, privacy-focused messaging app that allows
                    users to communicate securely and anonymously.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-sm-12 col-md-6 col-lg-5">
              <div className="discovercontent">
                <div className="image">
                  <img src="/images/eco2.png" alt="" />
                </div>
                <div className="contenttxt">
                  <h4>Z Short Vids</h4>
                  <p>
                    A platform for users to share short videos, from personal
                    moments to product promotions.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-sm-12 col-md-6 col-lg-5">
              <div className="discovercontent">
                <div className="image">
                  <img src="/images/eco3.png" alt="" />
                </div>
                <div className="contenttxt">
                  <h4>Z Shop</h4>
                  <p>
                    A decentralized e-commerce platform that enables users to
                    buy and sell products directly within the app.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-sm-12 col-md-6 col-lg-7">
              <div className="discovercontent">
                <div className="image">
                  <img src="/images/eco4.png" alt="" />
                </div>
                <div className="contenttxt">
                  <h4>Z Pay</h4>
                  <p>
                    A decentralized payment system that enables fast, secure,
                    and affordable transactions.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Ecosystem;
